import { all, spawn } from "redux-saga/effects";
import vertexSaga from "./sagas";

export default function* root() {
  yield all([spawn(vertexSaga)]);
}
